const CONFLUENCE_AUTH_KEY = 'confluence_auth';

export const confluenceAuthStorage = {
  set: (authData) => {
    localStorage.setItem(CONFLUENCE_AUTH_KEY, JSON.stringify(authData));
  },

  get: () => {
    const data = localStorage.getItem(CONFLUENCE_AUTH_KEY);
    if (data) {
      try {
        const parsed = JSON.parse(data);
        return { is_authenticated: parsed.is_authenticated || false };
      } catch {
        return { is_authenticated: false };
      }
    }
    return { is_authenticated: false };
  },

  remove: () => {
    localStorage.removeItem(CONFLUENCE_AUTH_KEY);
  },

  has: () => {
    const data = confluenceAuthStorage.get();
    return data.is_authenticated;
  },

  clear: () => {
    localStorage.removeItem(CONFLUENCE_AUTH_KEY);
  },
};
